<template>
  <div>
    <v-row>
      <v-spacer />
      <v-progress-circular
        v-if="loading"
        class="mt-6 mr-2"
        indeterminate
        color="primary"
      />
      <v-col cols="2">
        <v-menu
          v-model="showPickerFrom"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="date_from"
              label="Od (dátum)"
              readonly
              v-on="on"
            />
          </template>
          <v-date-picker
            v-model="date_from"
            no-title
            first-day-of-week="1"
            @input="showPickerFrom = false"
          />
        </v-menu>
      </v-col>
      <v-col cols="2">
        <v-menu
          v-model="showPickerTo"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="date_to"
              label="Do (dátum)"
              readonly
              v-on="on"
            />
          </template>
          <v-date-picker
            v-model="date_to"
            no-title
            first-day-of-week="1"
            @input="showPickerTo = false"
          />
        </v-menu>
      </v-col>
    </v-row>
    <v-row
      v-for="(subform, index) in series"
      :key="index"
    >
      <v-col>
        <h2>{{ index }}</h2>
        <v-row
          v-for="(item, index_2) in subform"
          :key="index_2"
        >
          <v-col>
            <v-subheader>{{ index_2 }}</v-subheader>

            <div>
              <apexchart
                type="bar"
                height="300"
                :options="chartOptions"
                :series="item"
              />
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Vue from "vue";
import { APIService } from "@/http/APIService.js";
import VueApexCharts from "vue-apexcharts";
import moment from "moment";

Vue.component("apexchart", VueApexCharts);

const apiService = new APIService();

export default {
  data: () => ({
    loading: false,
    date_from: "2019-10-01",
    date_to: moment().format("YYYY-MM-DD"),

    showPickerFrom: false,
    showPickerTo: false,

    series: {},
    chartOptions: {
      chart: {
        toolbar: {
          show: true
        }
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            legend: {
              position: "bottom",
              //   offsetX: -10,
              offsetY: 0
            }
          }
        }
      ],
      plotOptions: {
        bar: {
          horizontal: false
        }
      },

      xaxis: {
        labels: {
          rotate: -90
        },
        type: "category"
      },
      legend: {
        position: "right",
        offsetY: -5
      },
      fill: {
        opacity: 1
      }
    }
  }),

  watch: {
    date_from(val) {
      val && this.getStatisticsGraphsDetails();
    },
    date_to(val) {
      val && this.getStatisticsGraphsDetails();
    }
  },

  mounted() {
    this.getStatisticsGraphsDetails();
  },

  methods: {
    getStatisticsGraphsDetails() {
      this.loading = true;
      apiService
        .getStatisticsGraphsDetails(this.date_from, this.date_to)
        .then(response => {
          this.series = response;
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped>
.apexcharts-legend-text {
  position: absolute;
}
.apexcharts-legend-marker {
  position: absolute;
}
</style>